import refreshIcon from "@assets/images/icons/refresh.png";
import { Captcha, ICaptcha } from "@common/models";
import { IAppState } from "@misc/State";
import Translate from "@service/Translate";
import { Action, captchaApi, reloadCaptcha } from "@service/proxy";
import { nameof, validationMessage } from "@utilize/Util";
import { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "./general/form/Button";
import TextInput from "./general/form/TextInput";
import { AppAction, IAppAction } from "@misc/Action";
import { IModelValidationMessage, IValidationError } from "@core/index";
import Form from "./general/form/Form";

export interface ICaptchaPopup {
    visible: boolean;
    loading: boolean;
    error: boolean;
    onSubmit?: (captchaId: string, captchaChallenge: string) => void;
}

const CaptchaPopup: FC = () => {
    const { tr } = Translate;
    const dispatch = useDispatch();
    const [captcha, setCaptcha] = useState<ICaptcha>({});
    const [validationError, setValidationError] = useState<IValidationError>({});
    const formErrorsMessages: IModelValidationMessage = {
        text: {
            required: tr("err_record_required", tr("image_text")),
            maxLength: tr("err_captcha_text_max"),
            invalid: tr("err_invalid_captcha"),
        },
    };

    const { captchaPopup } = useSelector((state: IAppState) => ({
        captchaPopup: state.captchaPopup
    }));

    useEffect(() => {
        if (captchaPopup.visible) {
            // document.documentElement.classList.add("overflow-hidden");
            if (!captchaPopup.loading)
                loadCaptcha();
            if (captchaPopup.error)
                setValidationError({
                    text: 'invalid'
                });
            else
                setValidationError({});
        } else {
            // document.documentElement.classList.remove("overflow-hidden");
        }
    }, [captchaPopup]);

    useEffect(() => {
        return (() => document.documentElement.classList.remove("overflow-hidden"))
    }, []);

    const loadCaptcha = () => {
        captchaApi(Action.GET)
            .then((response) => {
                setCaptcha(response.content);
            })
    }

    const reLoadCaptcha = () => {
        if (captcha.captchaId)
            reloadCaptcha(Action.GET, captcha.captchaId)
                .then((response) => {
                    setCaptcha(response.content);
                })
    }

    const onSubmit = () => {
        let captchaRequest = new Captcha(captcha);
        const vaildateError = captchaRequest.validate();
        if (vaildateError)
            return setValidationError(vaildateError);

        dispatch<IAppAction>({ type: AppAction.Recaptcha, payload: { captchaPopup: { visible: false, loading: true, error: false } } });

        if (captchaPopup.onSubmit && captcha.captchaId && captcha.text)
            captchaPopup.onSubmit(captcha.captchaId, captcha.text);
    }

    const error = validationError ? validationMessage(formErrorsMessages, validationError) : {};

    return (
        captchaPopup.visible ?
            <div className="captcha-popup" >
                <div className="captcha-popup-root" />
                <div className="captcha-popup-container">
                    <Form onSubmit={onSubmit}>
                        <div className="captcha-popup-header">
                            <img
                                src={`data:image/png;base64,${captcha?.image}`}
                                alt={tr("image_of", "captcha")}
                                className="captcha-image"
                            />
                            <img
                                src={refreshIcon}
                                alt={tr("image_of", "refresh")}
                                className="reload-image"
                                onClick={reLoadCaptcha}
                            />
                        </div>
                        <TextInput
                            label={tr('image_text')}
                            autoComplete="off"
                            dir="ltr"
                            type="tel"
                            autoFocus={true}
                            name={nameof<ICaptcha>("text")}
                            value={captcha.text}
                            error={error.text}
                            max={6}
                            onChange={(name, value) => setCaptcha({ ...captcha, [name]: value })}
                        />
                        <Button
                            color="primary"
                            variant="contained"
                            height="48px"
                            text={tr('btn_send')}
                            type="submit"
                        />
                    </Form>
                </div>
            </div> : null
    )
}

export default CaptchaPopup;